import {Link} from 'react-router-dom';
import {Loading} from '../common';
import lion from '@/assets/reference-v2/original-lion.png';
import './DesignLoading.css';

/** Never render a legacy scene while the current employee image is pending. */
export default function DesignLoading({failed=false,onRetry}){
 return <>
  <div className="design-loading-mobile app-bg min-h-screen"><Loading/></div>
  <main className="design-loading" data-testid="current-design-loading" aria-busy={!failed}>
   <section role={failed?'alert':'status'}>
    <img src={lion} alt="" width="80" height="80"/>
    <h1>LÖWENSTARK</h1>
    <p>{failed?'Deine aktuelle Ansicht ist gerade nicht verfügbar.':'Deine Ansicht wird geladen …'}</p>
    {failed?<div><button onClick={onRetry}>Erneut laden</button><Link to="/m/profile">Zum Profil</Link></div>:<span className="design-loading-line" aria-hidden="true"/>}
   </section>
  </main>
 </>;
}
